import { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'clsx';
import RadioButtonGroup from '../shared/form/RadioButtonGroup';
import RadioButton from '../shared/form/RadioButton';
import RadioButtonLabel from '../shared/form/RadioButtonLabel';
import billingFrequency from '../../utils/subscription/billingPeriod';
import radioCss from '../shared/form/radio-button.module.scss';
import css from './payment.module.scss';

export default class SubscriptionRadioOptions extends Component {
  static propTypes = {
    products: PropTypes.array.isRequired,
    setSelectedProductSku: PropTypes.func.isRequired,
    selectedProduct: PropTypes.object.isRequired,
    isPairingFlow: PropTypes.bool,
  };

  onRadioButtonChange = (event, newVal) => {
    const { setSelectedProductSku } = this.props;
    setSelectedProductSku(newVal);
  };

  render() {
    const { isPairingFlow, products, selectedProduct } = this.props;
    const yearlyCss = products.length > 1 ? css.rightProduct : css.leftProduct;

    const radioLabelStyle = isPairingFlow
      ? {
          color: 'white',
          flexDirection: 'column',
        }
      : {
          color: 'black',
        };

    return (
      <div className="row">
        <div data-testid="productsContainer" className="col-xs-12">
          <Field
            name="selectedProductSku"
            type="radio"
            component={RadioButtonGroup}
            selectedValue={selectedProduct.sku}
            onChange={this.onRadioButtonChange}
          >
            {products.map((product) => {
              switch (product.billingPeriod) {
                case billingFrequency.yearly:
                  return (
                    <RadioButton
                      dataTestId="tuneInYearly"
                      value={product.sku}
                      key={product.sku}
                      label={<RadioButtonLabel product={product} />}
                      className={classNames(
                        radioCss.radio,
                        radioCss.inline,
                        css.column,
                        yearlyCss,
                        {
                          [radioCss.isPairingFlow]: isPairingFlow,
                        },
                      )}
                      labelStyle={radioLabelStyle}
                      labelDataTestId="tuneInYearlyRadioButton"
                      iconClassName={classNames(radioCss.icon, {
                        [radioCss.inkIcon]: isPairingFlow,
                        [radioCss.coralIcon]: !isPairingFlow,
                      })}
                    />
                  );
                case billingFrequency.monthly:
                  return (
                    <RadioButton
                      dataTestId="tuneInMonthly"
                      value={product.sku}
                      key={product.sku}
                      label={<RadioButtonLabel product={product} />}
                      className={classNames(
                        radioCss.radio,
                        radioCss.inline,
                        css.column,
                        css.leftProduct,
                        {
                          [radioCss.isPairingFlow]: isPairingFlow,
                        },
                      )}
                      labelStyle={radioLabelStyle}
                      labelDataTestId="tuneInMonthlyRadioButton"
                      iconClassName={classNames(radioCss.icon, {
                        [radioCss.inkIcon]: isPairingFlow,
                        [radioCss.coralIcon]: !isPairingFlow,
                      })}
                    />
                  );
                case billingFrequency.quarterly:
                  return (
                    <RadioButton
                      dataTestId="tuneInQuarterly"
                      value={product.sku}
                      key={product.sku}
                      label={<RadioButtonLabel product={product} />}
                      className={classNames(
                        radioCss.radio,
                        radioCss.inline,
                        css.column,
                        css.leftProduct,
                      )}
                      labelStyle={radioLabelStyle}
                      labelDataTestId="tuneQuarterlyRadioButton"
                      iconClassName={classNames(radioCss.icon, {
                        [radioCss.inkIcon]: isPairingFlow,
                        [radioCss.coralIcon]: !isPairingFlow,
                      })}
                    />
                  );
                default:
                  return null;
              }
            })}
          </Field>
        </div>
      </div>
    );
  }
}
